<template>
  <div class="visa-page">
    <h1>签证服务</h1>

    <div class="trv-card">
      <h2>TRV临时居民签证</h2>
      <p>按照加拿大政府的规定：所有外国人必须持有有效的签证才能进入加拿大。对于来自签国家的居民来说，需持有有效的电子旅行许可证Electronic Travel Authorization (eTA)，而对于需要签证的国家或地区的申请者则需持有临时居民签证Temporary Resident Visa (TRV)。中国公民无论是来加拿大学习、工作、探亲、旅游等从事商业活动都必须需持有TRV才能进入加拿大，TRV有效期最长为10年。</p>
      <button class="details-btn" @click="$router.push('/visa/trv')">详细内容</button>
    </div>

    <div class="visa-grid">
      <div class="visa-category">
        <div class="category-header visitor">
          <h2>访问签证</h2>
        </div>
        <div class="category-content">
          <div class="visa-item" @click="$router.push('/visa/visitor')">
            <h3>旅游探亲签证Visitor Visa</h3>
            <p>适用于来加拿大进行旅游探亲等的外国人签证申请，有效期长达十年。</p>
          </div>
          <div class="visa-item" @click="$router.push('/visa/super')">
            <h3>父母超级签证Super Visa</h3>
            <p>超级签证是专门为加拿大公民或永久居民的父母或祖父母设计的一种长达10年的多次往返探亲签证。</p>
          </div>
          <div class="visa-item" @click="$router.push('/visa/business')">
            <h3>商务签证Business Visitor Visa</h3>
            <p>商务签证是为商务活动的外国人设计的签证，商务活动包括：短期商务考察、洽谈业务、商务会议会展、商务培训等。</p>
          </div>
        </div>
      </div>

      <div class="visa-category">
        <div class="category-header study" @click="$router.push('/visa/study')">
          <h2>学习签证</h2>
        </div>
        <div class="category-content">
          <div class="visa-item" >
            <h3>国际留学生项目新政</h3>
            <p>目前，IRCC正在对国际留学生学习项目进行改进，以保护那些真正想来加拿大学习的国际留学生免于欺诈。</p>
          </div>
          <div class="visa-item">
            <h3>重要学签申请表格通知</h3>
            <p>11月28日IRCC已在公共网站上发布重要申请表格提醒通知：从2023年12月1日起生效的新规定。</p>
          </div>
          <div class="visa-item">
            <h3>学生直入计划SDS</h3>
            <p>为具备一定英语能力并持直接授进入DLI就读的学生提供的一个简单和快速的学习签证申请程序。</p>
          </div>
          <div class="visa-item">
            <h3>学签延期Extension与恢复Restoration</h3>
            <p>学签在到期90天后无效，学签延期应在学签到期前30天申请。如果在学签到期后延误又延期的申请，则被视为恢复学习身份。</p>
          </div>
        </div>
      </div>

      <div class="visa-category">
        <div class="category-header work">
          <h2>工作签证</h2>
        </div>
        <div class="category-content">
          <div class="visa-item">
            <h3>LMIA工签</h3>
            <p>LMIA (Labour Market Impact Assessment) 是加拿大雇主在雇佣外籍员工前必须获得的劳动力市场影响评估。</p>
          </div>
          <div class="visa-item">
            <h3>配偶开放工签SOWP</h3>
            <p>配偶工签是指随一方在加拿大持有学签或工签，或配偶方在加拿大境内已经过了工配偶申请移民申请。</p>
          </div>
          <div class="visa-item">
            <h3>毕业后工签PGWP</h3>
            <p>国际留学生从加拿大毕业后，在获得DLI的书面确认（例如正式成绩或毕业证书）后可申请。</p>
          </div>
        </div>
      </div>

      <div class="visa-category">
        <div class="category-header special">
          <h2>特殊证件申请</h2>
        </div>
        <div class="category-content">
          <div class="visa-item">
            <h3>复议请求Reconsideration</h3>
            <p>当申请人的永久居民申请或临时居民签证申请被拒绝时，如果申请人认为签证官的决定有误可以申请复议。</p>
          </div>
          <div class="visa-item">
            <h3>永久居民旅行证件PRTD</h3>
            <p>对于身份加拿大永久居民的持有卡过期，损坏，遗失等原因，返回加拿大时必须持有有效的证件。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisaView'
}
</script>

<style lang="less" scoped>
.visa-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  h1 {
    text-align: center;
    margin-bottom: 30px;
    color: #333;
  }

  .trv-card {
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    margin-bottom: 40px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    h2 {
      color: #333;
      margin-bottom: 20px;
    }

    p {
      color: #666;
      line-height: 1.8;
      margin-bottom: 20px;
    }

    .details-btn {
      background: #e63946;
      color: white;
      border: none;
      padding: 10px 25px;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      transition: background 0.3s;

      &:hover {
        background: darken(#e63946, 10%);
      }
    }
  }

  .visa-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;

    .visa-category {
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-5px);
      }

      .category-header {
        padding: 20px;
        color: white;
        text-align: center;

        &.visitor { background: #e63946; }
        &.study { background: #e63946; }
        &.work { background: #e63946; }
        &.special { background: #e63946; }

        h2 {
          margin: 0;
          font-size: 22px;
        }
      }

      .category-content {
        padding: 20px;

        .visa-item {
          margin-bottom: 25px;

          &:last-child {
            margin-bottom: 0;
          }

          h3 {
            color: #333;
            margin-bottom: 10px;
            font-size: 18px;
          }

          p {
            color: #666;
            line-height: 1.6;
            margin: 0;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .visa-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>